export const serviceCodeMap: Record<string, string> = {
  ER: 'Emergency Response Services',
  FIS: 'Field & Industrial Services',
  'T&D': 'Treatment & Disposal Services',
  'E&P': 'E & P Services',
};

export const serviceNameMap: Record<string, string> = {
  'Emergency Response Services': 'ER',
  'Field & Industrial Services': 'FIS',
  'Treatment & Disposal Services': 'T&D',
  'E & P Services': 'E&P',
};
